import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PriceDetail from 'modules/billing/components/PriceDetail'
import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'
import { DEFAULT_CURRENCY, MIN_SEATS } from 'modules/onboarding/lib/pricing/plans/utils'

import * as styles from './index.vanilla.css'

const PricingSection = ({ hubsSectionRef }: { hubsSectionRef: React.RefObject<HTMLElement> }) => {
  const {
    allPlans,
    isYearly,
    isCoreEnterpriseMandatory,
    computePerSeatPrice,
    computeTotalPrice,
    getSubscriptionItems,
  } = usePricingContext()

  const totalPrice = computeTotalPrice(MIN_SEATS)
  const perSeatPrice = computePerSeatPrice()
  const currency = allPlans.corePlans[0]?.pricing?.currency || DEFAULT_CURRENCY
  const commonProps = {
    isYearly: isYearly(),
    bundleSubscriptionItems: getSubscriptionItems(MIN_SEATS),
    currency,
    seats: MIN_SEATS,
    minimumSeats: MIN_SEATS,
    perSeatPrice,
    totalPrice,
    isPersonalisedHub: true,
    disableButton: isCoreEnterpriseMandatory(),
  }

  const onClick = () => {
    hubsSectionRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <Box padding="s48" style={{ flex: '1' }}>
      <Text.Header1>{i18n.t('pricing_plans.personalised_hub.price_section.title')}</Text.Header1>
      <Box paddingTop="s16">
        <Text.Normal color="grey800">
          {i18n.t('pricing_plans.personalised_hub.price_section.description')}
        </Text.Normal>
      </Box>
      <PriceDetail.Trial {...commonProps} />
      <Text.Normal weight="semibold">
        {i18n.t('pricing_plans.personalised_hub.price_section.question')}
      </Text.Normal>
      <Box flexDirection="row" gap="s4" flexWrap="wrap">
        <Box cursor="pointer" className={styles.linkItem} onClick={onClick}>
          <Text.Normal color="viridian1200">
            {i18n.t('pricing_plans.personalised_hub.price_section.link')}
          </Text.Normal>
        </Box>
        <Text.Normal>{i18n.t('pricing_plans.personalised_hub.price_section.text')}</Text.Normal>
      </Box>
    </Box>
  )
}

export default PricingSection
